import motorRisk from "@/api/credit-operation/motor-risk";
import { baseState, baseMutations } from "@/store/mixins";

export const state = {
    ...baseState,
    customers: [],
    riskStatus: [],
    currencies: []
};

export const getters = {};

export const mutations = {
    ...baseMutations,
    SET_CUSTOMERS(state, data) {
        state.customers = data;
    },
    SET_RISK_STATUS(state, data) {
        state.riskStatus = data;
    },
    SET_CURRENCIES(state, data) {
        state.currencies = data;
    },
    CLEAR_RESOURCES(state) {
        state.customers = [];
        state.riskStatus = [];
        state.currencies = [];
    }
};

export const actions = {
    fetch(context, attributes = {}) {
        let params = Object.assign(
            {
                page: context.state.pagination.page,
                perPage: context.state.pagination.perPage,
                filter: {
                    search: context.state.search
                }
            },
            attributes
        );
        return motorRisk.get({ params }).then(response => {
            context.commit("RECEIVE_RESOURCES", response);
            return Promise.resolve(response);
        });
    },
    store(context, data) {
        return motorRisk.store(data);
    },
    update(context, { id, data }) {
        return motorRisk.update(id, data);
    },
    destroy(context, { id, data }) {
        return motorRisk.destroy(id, data);
    },
    async getCustomers(context) {
        let response = await motorRisk.customer();
        context.commit("SET_CUSTOMERS", response.data);
    },
    async getRiskStatus(context) {
        let response = await motorRisk.riskStatus();
        context.commit("SET_RISK_STATUS", response.data);
    },
    async getCurrencies(context) {
        let response = await motorRisk.currency();
        context.commit("SET_CURRENCIES", response.data);
    }
};